// extracted by mini-css-extract-plugin
export default {"p":"_0906be79b6 bf4ba03fb8 _103b26ad2a","clr":"cf8e1ab856","dls":"_97ef027442"};